<template>
  <ol
    class="spoiler_content"
  >
    <li v-html="rulesUrl" />
    <li>{{ $t('2. Обратите внимание, что ежемесячное начисление внутриигровой валюты осуществляется до 15 числа месяца, следующего за отчетным.') }}</li>
    <li v-html="bankSupportUrl" />
  </ol>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import { getRulesUrl, getBankSupportUrl } from '@/helpers'
@Component({})
class WhereIsMyAccuralsAlfa extends Vue {
  @Prop({ type: String, required: true }) partner

  get rulesUrl () {
    return this.$t(
      '1. В истории начисления бонусов содержится информация только о ежемесячном возврате внутриигровой валюты и дополнительных бонусах за оборот по карте, в соответствии с %(link_start)sправилами программы%(link_stop)s.',
      { link_start: `<a class='link' target='_blank' href='${getRulesUrl(this.partner)}'>`, link_stop: `</a>` }
    )
  }

  get bankSupportUrl () {
    return this.$t(
      '3. При возникновении вопросов касательно суммы начисленной внутриигровой валюты обратитесь в %(link_start)sслужбу поддержки Альфа Банк%(link_stop)s.',
      { link_start: `<a class='link' href="${getBankSupportUrl(this.partner)}" target="_blank">`, link_stop: '</a>' }
    )
  }
}

export default WhereIsMyAccuralsAlfa
</script>
